import { Toaster } from "sonner";
import "./AppToaster.css";

const AppToaster = () => (
  <Toaster
    theme="light"
    position="top-right"
    closeButton={false}
    richColors={false}
    expand={false}
    gap={12}
    visibleToasts={3}
    offset={20}
    toastOptions={{
      unstyled: true,
      className: "cotify-toast-host",
    }}
  />
);

export default AppToaster;
